import React, {useEffect, useState, ChangeEvent, KeyboardEvent} from 'react';

function Pagetitle({pageObj}){

    const [pagetitle, setPagetitle] = useState("");
    
    //"Point-On-Sale";
    const home = "Home";
    const location = "POS";

    const checkPagetitle = () => {
      /*if(pageObj.title){
        setPagetitle(pageObj.title);
      }*/
      if(pagetitle === ""){
        setPagetitle("nonTitle");
      }
    }
    useEffect(() => {
      checkPagetitle();
    }, []);
    return(
      <div className="pagetitle">
        <h1>{pagetitle}</h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="index.html">{home}</a></li>
            <li className="breadcrumb-item active">{location}</li>
          </ol>
        </nav>
      </div>
    );
}


export default Pagetitle;